import React from "react";

const Footers = () => {
  return (
    <footer className="test justify-center items-center h-40 bg-slate-100 flex">
      <p>Movie App ©2022 Created by Muhammad Nizar Fazari</p>
    </footer>
  );
};

export default Footers;
